<template>
  <v-layout column>
    <v-flex xs11 offset-xs0>
      <panel v-bind:title='title'>
        <!-- <v-btn v-if ='$store.state.isEditor'
          slot="action"
          class="indigo accent-1"
          :to="{path: '/rankEdit/' + rankType + '/' + id}"
          light
          medium
          absolute
          right
          small
          fab
        >
          <v-icon>edit</v-icon>
        </v-btn>         -->
        <RankEdit v-if ='$store.state.isEditor' slot="action"/>
        <div slot="top">
          <H3>People with a rank of {{ title }} </H3>
          <PeopleSearchTable v-bind:forceRankId="id" v-bind:forceRankType="rankType" v-bind:showRankCol='false'/>
        </div>         
      </panel>
            
    </v-flex>
  </v-layout>
</template>

<script>

import Panel from "@/components/Panel" ;
import PeopleSearchTable from "@/components/PeopleSearchTable" ;
import RankService from "@/services/RankService" ;
import RankEdit from "./RankEdit" ;

export default {
  components: {
    Panel, PeopleSearchTable, RankEdit
  },
  data () {
    return {
      rankType: this.$route.params.rankType,
      id: parseInt(this.$route.params.id),
      rank: {},
      title: "Loading Rank " + this.$route.params.id
    }
  },
  async created () {
    await this.$getCodes() ;  // needed for everything - make sure we have them and they are up to date
  },  
  async mounted () {
    console.log("in rank mounted") ;
    await this.readData() ;
  },
  methods: {
    async readData () {
      console.log("off to RankService id, type = " + this.rankType + ", id=" + this.id) ;
      const result = await RankService.id(this.rankType, this.id) ;
      this.rank = result.data ;
      this.title = this.$codeToService(this.rank.type) + ": " + this.rank.v ;
      // console.log("Back  from us, this.rank=" + JSON.stringify(result)) ;     
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Rank.vue